import { Title } from '../../../queries/ats/titles/types/title';

export type AgeLimitColors = 'green' | 'yellow' | 'orange' | 'red' | 'white';

export function ageColor(title: Title) {
  let rating: number = Number(title.ageRating);

  if (rating >= 0 && rating <= 8) {
    return 'green';
  }

  if (rating >= 9 && rating <= 14) {
    return 'yellow';
  }

  if (rating >= 15 && rating <= 17) {
    return 'orange';
  }

  if (rating >= 18) {
    return 'red';
  }

  return 'white';
}
